import { render } from "./thbHome.vue?vue&type=template&id=5af353e0&scoped=true"
import script from "./thbHome.vue?vue&type=script&lang=js"
export * from "./thbHome.vue?vue&type=script&lang=js"

import "./thbHome.vue?vue&type=style&index=0&id=5af353e0&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af353e0"]])

export default __exports__